<div class="slider">
  <splide [options]="sliderOptions" class="slider slider--pink">
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/game/slides/darts/slide1.svg" alt="Slide 1" class="m-auto">
        </div>
        <div class="slider__desc">
          Your <strong>15 coins</strong> relate to <strong>15 scores</strong> that can happen during the darts match.
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/game/slides/darts/slide2.svg" alt="Slide 2" class="m-auto">
        </div>
        <div class="slider__desc">
          Player A's scores are on the left, Player B's on the right. 3 (in the middle) are checkout scores from either Player.
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/game/slides/darts/slide3.svg" alt="Slide 3" class="m-auto">
        </div>
        <div class="slider__desc">
          If a score happens that you have on your card, that coin turns purple.
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/game/slides/darts/slide4.svg" alt="Slide 4" class="m-auto">
        </div>
        <div class="slider__desc">
          If you’re <strong>first to get 1 and/or 2 Lines</strong>, you <strong>win a prize.</strong>
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/game/slides/darts/slide5.svg" alt="Slide 5" class="m-auto">
        </div>
        <div class="slider__desc">
          If <strong>all your 15 scores happen first</strong> in the match, you <strong>get a Full House</strong>, and you <br> <strong>win the main prizepot.</strong>
        </div>
      </div>
    </splide-slide>
  </splide>
</div>
